import AdditionalFields from 'Components/Client/Cases/CaseDetails/AdditionalFields'
import React from 'react'

function AdditionalFieldsOnProfContent({caseDetails}) {
  return (
    <>
        {caseDetails && caseDetails?.additionalFields && Object.entries(caseDetails?.additionalFields).length 
        ?
        <div className='flex w-full '>
                <div className='shadow-xl border w-full p-4  mt-10'>
                    <div className='font-bold text-md mb-6 text-green-700 underline'>Additional Case details </div>
                    <AdditionalFields
                        additionalFields={JSON.parse(caseDetails?.additionalFields)}
                    />
        </div>
        </div>
        :
        ""
        }
    </>
  )
}

export default AdditionalFieldsOnProfContent